import "./styles.scss";
import { Close, RedExclamationCircle } from "../../assets/svgs";
import CustomButton from "../CustomButton";
import CampaignHeader from "../CampaignHeader";

const CustomErrorModal = ({
  showPopup,
  title,
  message,
  primaryBtnText,
  secondaryBtnText,
  handlePrimaryButton,
  handleSecondaryButton,
  onClickClose,
  hideButton = false,
}) => {
  if (!showPopup) return null;

  return (
    <div className="custom-error-container">
      <CampaignHeader
        darkLogo={true}
        logoStyle={{ height: "56px", width: "256px" }}
        containerStyle={{ boxShadow: "0 1px 2px 0 rgba(10, 13, 18, 0.05)" }}
        onClickClose={onClickClose}
        hideBtn
        isCrossButton
      />
      <div className="error-image-wrapper">
        <img src={RedExclamationCircle} alt="error" className="error-image" />
      </div>
      <h2 className="screen-title">{title}</h2>
      <p className="screen-description">{message}</p>

      {!hideButton ? (
        <div className="footer-contianer">
          <CustomButton
            text={primaryBtnText}
            style={{ maxWidth: "90%" }}
            onClick={handlePrimaryButton}
            buttonClassText={"button-text"}
          />
          <CustomButton
            text={secondaryBtnText}
            style={{ maxWidth: "90%" }}
            onClick={handleSecondaryButton}
            buttonClassText={"button-secondary-text"}
            btnVariant="btn-primary-50"
          />
        </div>
      ) : null}
    </div>
  );
};

export default CustomErrorModal;
